<template>
    <div class="panel">
        <div
                class="panel__title"
                :class="checkbox ? 'is-active': ''"
        >
            On
        </div>
        <label class="panel__switcher">
            <input :checked="!checkbox" class="panel__switcher-input" type="checkbox" @click="toggleCheckbox">
            <div class="panel__switcher-slider"></div>
        </label>
        <div class="panel__title">Off</div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'protection_area'],
        data() {
           return {
               checkbox: true
           }
        },
        methods: {
            toggleCheckbox() {
                this.checkbox = !this.checkbox;
                this.updateLocation(+this.checkbox)
            },
            updateLocation(state) {
                this.$store.dispatch('updateLocation', {id: this.id, protection_area_radius_enabled: state, setRadius: true, update: true})
            },
        },
        created() {
            this.checkbox = Boolean(this.protection_area)
        }
    }
</script>
<style lang="sass" scoped>

    .panel
        display: flex
        justify-content: space-between
        align-items: center
        width: 100%
        &__title
            color: #99A8B8
            +tr(color .3s ease)
            font-size: 12px
            line-height: 16px
            +reg
            &.is-active
                color: #6979F8
        &__switcher
            position: relative
            display: inline-block
            width: 32px
            height: 18px
            padding: 2px
            margin: 0 6px
            &-input
                display: none
                &:checked + .panel__switcher-slider
                  &:before
                    transform: translateY(-50%) translateX(15px)
                    background: #B2BDC9
                    box-shadow: 0px 2px 6px rgba(128, 145, 166, 0.15)
            &-slider
                position: absolute
                cursor: pointer
                top: 0
                left: 0
                right: 0
                bottom: 0
                box-shadow: 0px 0px 2px rgba(1, 37, 78, 0.3)
                background: #FFFFFF
                +tr(all .3s ease)
                border-radius: 10px
                &:before
                    position: absolute
                    content: ""
                    height: 14px
                    width: 14px
                    background: $color--blue
                    box-shadow: 0px 2px 6px rgba(22, 75, 221, 0.2)
                    +tr(all .3s ease)
                    top: 50%
                    border-radius: 50%
                    transform: translateY(-50%) translateX(4px)






</style>